import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import type { RouterHistory } from 'react-router';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { CheckCircleOutlineRounded } from '@material-ui/icons';
import { compose } from '../../utility';
import styles from './feedback.styles';
import Button from '../../shared/button/button';
import { withAppUser } from '../../shared/authorization';
import { messages } from './constants';
import { ESIGN_ENDPOINT } from '../../configurations';
import Cookies from 'js-cookie';
import CircularProgress from '@material-ui/core/CircularProgress';

type PropType = {
  classes: Object,
  history: RouterHistory,
};

type StateType = {
  isError: boolean,
  isPaymentProcessed: boolean,
  errorMsg: string,
  subscription: Object,
};

class Feedback extends React.PureComponent<PropType, StateType> {
  state = {
    isPaymentProcessed: false,
    isError: false,
    errorMsg: '',
    subscription: {},
  };
  async componentDidMount() {
    const params = new URL(String(document.location)).searchParams;
    const urlToken = params.get('userTokenId') || '';
    const authToken = Cookies.get('jwt');
    try {
      let res = await fetch(ESIGN_ENDPOINT + '/subscription', {
        method: 'PUT',
        body: JSON.stringify({
          token: urlToken,
        }),
        headers: {
          Authorization: `JWT ${authToken}`,
        },
      });

      let json = await res.json();
      if (res.status === 201) {
        this.setState({ subscription: json });
      } else {
        this.setState({ errorMsg: res.message, isError: true });
      }

      if (this.state.subscription && this.state.subscription.status === 1) {
        this.setState({ isPaymentProcessed: true });
        return;
      }

      res = await fetch(ESIGN_ENDPOINT + '/payment', {
        method: 'POST',
        headers: {
          Authorization: `JWT ${authToken}`,
        },
      });
      // json = await res.json()

      if (res.status === 200) {
        this.setState({ isPaymentProcessed: true });
        return;
      } else if (res.status === 201) {
        this.setState({ errorMsg: json.message });
      } else {
        this.setState({ errorMsg: json.message, isError: true });
        return;
      }
      let that = this;
      setTimeout(function () {
        fetch(ESIGN_ENDPOINT + '/subscription', {
          method: 'GET',
          body: null,
          headers: {
            Authorization: `JWT ${authToken}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              response.json().then((sub) => {
                if (sub && sub.status === 1) {
                  that.setState({ errorMsg: '', isError: false });
                }
              });
            } else {
              response.json().then((json) => {
                that.setState({ errorMsg: json.message });
              });
            }
            that.setState({ isPaymentProcessed: true });
          })
          .catch(() => {
            that.setState({ isError: true });
          });
      }, 20000);
    } catch (e) {
      console.log(e);
      this.setState({ isError: true });
    }
  }

  updateSubscription = (authToken, userId) => {
    const data = {
      token: token,
    };
    return fetch(ESIGN_ENDPOINT + '/subscription', {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        Authorization: `JWT ${authToken}`,
      },
    })
      .then((resp) => {
        if (resp.status === 201) {
          resp.json().then((res) => {
            this.setState({ subscription: res });
          });
        } else {
          resp.json().then((res) => {
            this.setState({ errorMsg: res.message });
          });
          this.setState({ isError: true });
        }
      })
      .catch(() => {
        this.setState({ isError: true });
      });
  };
  postPayment = (authToken) => {
    const data = {};
    return fetch(ESIGN_ENDPOINT + '/payment', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Authorization: `JWT ${authToken}`,
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          this.setState({ isPaymentProcessed: true });
        } else if (resp.status === 201) {
          resp.json().then((res) => {
            this.setState({ errorMsg: res.message });
          });
        } else {
          resp.json().then((res) => {
            this.setState({ errorMsg: res.message });
          });
          this.setState({ isError: true });
        }
      })
      .catch(() => {
        this.setState({ isError: true });
      });
  };
  handleClick = () => {
    this.props.history.push('/agent/sessions');
  };

  render() {
    const { classes } = this.props;
    const { errorMsg, isPaymentProcessed, isError } = this.state;
    return (
      <div className={classes.landing}>
        <Helmet
          titleTemplate="%s - RealDesk Esign"
          defaultTitle="RealDesk Esign"
        >
          <meta name="description" content="Agent Panel" />
          <title>New Session</title>
        </Helmet>
        <div className={classes.view}>
          <div className={classes.viewContent}>
            {!isPaymentProcessed && isError ? (
              <Card className={classes.card}>
                <div className={classes.titleContainer}>
                  <div className={classes.cardTitle}>
                    {messages.PAYMENT_NOT_COMPLETED}
                  </div>
                </div>
                <CardContent className={classes.cardContent}>
                  <div>{errorMsg ? errorMsg : ''}</div>
                  <div>{messages.PAYMENT_NOT_COMPLETED_NOTICE}</div>
                </CardContent>
                <CardActions className={classes.button}>
                  <Button
                    color="primary"
                    disableFocusRipple
                    onClick={this.handleClick}
                  >
                    {messages.VIEW_SIGNING_SESSIONS}
                  </Button>
                </CardActions>
              </Card>
            ) : (
              <Card className={classes.card}>
                {isPaymentProcessed ? (
                  <CheckCircleOutlineRounded className={classes.screenIcon} />
                ) : (
                  ''
                )}
                <div className={classes.titleContainer}>
                  <div className={classes.cardTitle}>
                    {isPaymentProcessed
                      ? messages.PAYMENT_COMPLETED
                      : messages.PAYMENT_PROCESSING}
                  </div>
                </div>
                <CardContent className={classes.cardContent}>
                  <div>
                    {isPaymentProcessed ? (
                      errorMsg ? (
                        errorMsg
                      ) : (
                        messages.PAYMENT_COMPLETED_NOTICE
                      )
                    ) : (
                      <CircularProgress
                        variant="indeterminate"
                        value={100}
                        size={30}
                        thickness={2}
                        className={classes.loader}
                      />
                    )}
                  </div>
                </CardContent>
                <CardActions className={classes.button}>
                  <Button
                    color="primary"
                    disableFocusRipple
                    onClick={this.handleClick}
                  >
                    {messages.VIEW_SIGNING_SESSIONS}
                  </Button>
                </CardActions>
              </Card>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
  withAppUser
)(Feedback);
